import { Stack } from '@mui/material'
import { useParams } from 'react-router'
import { EDIT_VISITOR_ROUTE_PARAM } from '~/features/routes'
import { useGetVisitor } from '~/features/visitors/hooks/useGetVisitor'
import { LoadingSkeletons } from '~/ui/components/LoadingSkeletons'
import { EditVisitorForm } from './EditVisitorForm'
import { useGetOrders } from '../orders/hooks/useGetOrders'

// TODO block deleting if it has a shopify assignee
export const VisitorFormLoader = () => {
  const params = useParams<{ [EDIT_VISITOR_ROUTE_PARAM]: string }>()
  const visitorEntryId = params[EDIT_VISITOR_ROUTE_PARAM]
  const { data: visitor, isLoading: isVisitorLoading } = useGetVisitor({ id: visitorEntryId })
  const { data: orders, isLoading: isLoadingOrders } = useGetOrders()

  const canDelete = !orders.some((o) => o.visitor?.id === visitor?.id)

  const isLoading = isLoadingOrders || isVisitorLoading

  return (
    <Stack overflow="hidden" flex={1}>
      {isLoading ? (
        <LoadingSkeletons length={6} />
      ) : visitor ? (
        <EditVisitorForm visitor={visitor} canDelete={canDelete} />
      ) : null}
    </Stack>
  )
}
